// Translations object
export const translations = {
  en: {
    success: "Success",
    error: "Error",
    important: "Important",
    fillTypeAmount: "Please fill in the type and amount",
    deductionAddedSuccess: "Deduction added successfully!",
    errorAddingDeduction: "An error occurred while adding the deduction",
    noDescription: "No description",
    employeeDataUpdatedSuccess: "Employee data updated successfully",
    errorSavingEmployeeData: "Error saving employee data",
    payrollProcessedSuccess:
      "Payroll processed successfully for {count} employees!",
    payrollProcessingError: "Error processing payroll: {error}",

    // Employee Details Modal    // Employee Details Modal
    employeeDetailsTitle: "Employee Details & Payroll Information",
    edit: "Edit",
    cancel: "Cancel",
    saveChanges: "Save Changes",
    saving: "Saving...",

    // Personal Information
    personalInformation: "Personal Information",
    fullName: "Full Name",
    employeeId: "Employee ID",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    emergencyPhone: "Emergency Phone",
    nationalId: "National ID",
    dateOfBirth: "Date of Birth",
    gender: "Gender",
    selectGender: "Select Gender",
    male: "Male",
    female: "Female",
    maritalStatus: "Marital Status",
    selectStatus: "Select Status",
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    nationality: "Nationality",
    city: "City",
    country: "Country",
    address: "Address",
    showing: "Showing",
    of: "of",
    previous: "Previous",
    next: "Next",

    // Work Information
    workInformation: "Work Information",
    department: "Department",
    position: "Position",
    hiringDate: "Hiring Date",
    contractType: "Contract Type",
    selectType: "Select Type",
    fullTime: "Full-time",
    partTime: "Part-time",
    contract: "Contract",
    temporary: "Temporary",
    workingHours: "Working Hours",
    contractExpiration: "Contract Expiration",
    directManager: "Direct Manager",
    workLocation: "Work Location",
    employmentStatus: "Employment Status",

    // Salary & Earnings
    salaryAndEarnings: "Salary & Earnings",
    basicSalary: "Basic Salary",
    bonus: "Bonus",
    overtimeHours: "Overtime Hours",
    overtimeTotal: "Overtime Total",
    transportationAllowance: "Transportation Allowance",
    mealAllowance: "Meal Allowance",
    mobileAllowance: "Mobile Allowance",
    bonusAdjustments: "Bonus Adjustments",
    grossSalary: "Gross Salary",
    payrollSettings: "Payroll Settings",
    paymentMethod: "Payment Method",
    paymentDate: "Payment Date",
    processingOptions: "Processing Options",
    includeOvertime: "Include Overtime",
    includeBonuses: "Include Bonuses",
    processTaxes: "Process Income Tax",
    processInsurance: "Process Social Insurance",
    notes: "Notes (Optional)",
    addNotesPayroll: "Add any notes about this payroll run...",
    reviewProcess: "Review & Process",
    payrollSummary: "Payroll Summary",
    employees: "Employees",
    grossTotal: "Gross Total",
    deductions: "Deductions",
    taxInsurance: "Tax & Insurance",
    netTotal: "NET TOTAL",
    employeeBreakdown: "Employee Breakdown",
    important: "Important",
    processPayrollWarning:
      "This action will process payroll for {count} employees and cannot be undone.",

    // Performance & KPI
    performanceKPI: "Performance & KPI",
    kpiScore: "KPI Score",
    performanceRating: "Performance Rating",
    excellent: "Excellent",
    good: "Good",
    satisfactory: "Satisfactory",
    needsImprovement: "Needs Improvement",

    // Banking Information
    bankingInformation: "Banking Information",
    bankName: "Bank Name",
    accountNumber: "Account Number",
    iban: "IBAN",
    branchCode: "Branch Code",

    // Action Buttons
    downloadPayslip: "Download Payslip",
    sendViaEmail: "Send via Email",

    // Status Options
    active: "Active",
    paid: "Paid",
    pending: "Pending",
    processing: "Processing",
    onHold: "On Hold",
    // Header
    pageTitle: "Payroll System",
    currency: "EGP",
    nextStep: "Next Step",
    templateButton: "Template",
    templateButtonTitle: "View template details",
    templateBuilder: "Template Builder",
    templateBuilderSubtitle: "Choose the columns to include, or export everything.",
    buildCustomTemplate: "Build custom template…",
    exportFullTemplate: "Export Full Template",
    exportSelection: "Export",
    searchColumns: "Search columns…",
    kindAll: "All",
    kindAllowances: "Allowances",
    kindDeductions: "Deductions",
    showVariants: "Show",
    variantNet: "Net",
    variantGross: "Gross",
    variantDaysNet: "Days (Net)",
    variantDaysGross: "Days (Gross)",
    alwaysIncluded: "Always included",
    requiredColumns: "Required",
    columnsSelectedSummary: "{selected} of {total} columns",
    noColumnsSelected: "Select at least one column to export.",
    addColumn: "Add column",
    customColumnLabel: "Column name",
    customColumnKind: "Type",
    customColumnPreview: "Headers that will be created",
    customColumnStoredAs: "Stored as type",
    customColumnRecognised: "Recognised by the importer",
    customBadge: "Custom",
    presets: "Presets",
    fullTemplate: "Full template",
    newPreset: "New preset",
    savePreset: "Save preset",
    saveAsNew: "Save as new…",
    updatePreset: "Update \"{name}\"",
    presetModified: "Modified",
    presetName: "Name",
    presetDescription: "Description",
    presetScopePersonal: "Only me",
    presetScopeCompany: "Everyone in this company",
    setAsDefault: "Set as my default",
    duplicatePreset: "Duplicate",
    sharePreset: "Share",
    unsharePreset: "Unshare",
    deletePreset: "Delete",
    templatePresetSaved: "Template preset saved",
    templatePresetUpdated: "Template preset updated",
    templatePresetDeleted: "Template preset deleted",
    confirmDeletePreset: "Delete this preset? This cannot be undone.",
    confirmSharePreset: "Share this preset with everyone in the company?",
    presetNameTaken: "You already have a preset with this name.",
    errorLoadingColumns: "Could not load the column list.",
    errorExportingTemplate: "Could not build the template.",
    clearSearch: "Clear search",
    noColumnsMatch: "No columns match",
    selectedOfTotal: "{selected} selected / {total}",
    selectAllFiltered: "Select all",
    clearAllSelection: "Clear all",
    quantityColumnNotice: "Quantity column (hours/days)",
    // Action Buttons
    processPayroll: "Process Payroll",
    processPayrolltitle: "Process New Payroll",

    import: "Import",
    importExcel: "Import Excel",
    importAllowancesDeductions: "Import A/D",
    importAllowancesDeductionstitle: "Import Allowances & Deductions",

    exportTemplate: "Export Template",
    exportAllowanceDeductionTemplate: "Export A/D Template",
    exportAllowanceDeductionTemplatetitle: "Export Allowances/Deductions Template",

    exportPayrollExcel: "Export to Excel",
    exportPayrollPDF: "Download as PDF",
    exportDate: "Export Date",
    payrollExportSuccess: "Payroll exported to Excel successfully!",
    payrollExportSuccessPDF: "Payroll exported to PDF successfully!",
    payrollExportError: "Error exporting payroll to Excel",
    payrollExportErrorPDF: "Error exporting payroll to PDF",
    allowanceDeductionImportSuccess:
      "Allowances and deductions imported successfully",
    allowanceDeductionImportError: "Error importing allowances and deductions",
    importingAllowancesDeductions: "Importing allowances & deductions...",
    adImportResultsTitle: "Import Complete",
    adImportResultsSubtitle:
      "The file has been processed. Review the details below.",
    adImportTotal: "Total",
    adImportProcessed: "Processed",
    adImportFailed: "Failed",
    adImportDuplicates: "Duplicates",
    adImportAllowancesCreated: "Allowances Created",
    adImportDeductionsCreated: "Deductions Created",
    adImportNoIssues: "All rows imported successfully with no issues!",
    adImportErrorsSection: "Failed Rows",
    adImportDuplicatesSection: "Duplicate Rows Detected",
    adImportDuplicatesHint:
      "These employee/date combinations appear more than once in the uploaded file — every matching row was still imported, so double-check these aren't accidental repeats.",
    adImportEmployeeCode: "Employee Code",
    adImportDate: "Date",
    adImportOccurrences: "Occurrences",
    adImportReason: "Reason",
    // manageVisibility: "Manage Visibility",

    // Visibility Rules (UI removed translations retained for messages)
    visibilityAdded: "Visibility rule added successfully",
    visibilityRemoved: "Visibility rule removed successfully",
    loadingVisibilityRules: "Loading visibility rules...",
    noVisibilityRules: "No visibility rules configured",

    // Statistics
    totalGross: "Total Gross Salary",
    employeesPaid: "Employees Paid",
    pendingPayments: "Pending Payments",
    averageKPI: "Total Deductions",
    monthlyGross: "Monthly gross payroll",
    currentMonth: "Current month",
    awaitingApproval: "Awaiting approval",
    performanceIndicator: "Monthly total deductions",

    // Filters
    filterSearch: "Filter & Search",
    searchEmployees: "Search Employees",
    searchPlaceholder: "Search by name or employee ID...",
    paymentStatus: "Payment Status",
    allStatuses: "All Statuses",
    paid: "Paid",
    pending: "Pending",
    approved: "Approved/Processing",
    rejected: "Rejected/On Hold",
    department: "Department/Location",
    allDepartments: "All Departments",
    payPeriod: "Pay Period",
    payPeriodMonth: "Pay Period (Month)",
    payPeriodYear: "Pay Period (Year)",
    refreshData: "Refresh Data",
    activeFilters: "Active Filters",
    clearAll: "Clear All",
    workingCompany: "Working Company",
    allCompanies: "All Companies",
    laborMode: "Labor Mode",
    allLaborModes: "All Labor Modes",
    insource: "Insource",
    outsource: "Outsource",

    // Benefits
    benefitsPackage: "Employee Benefits Package",
    medicalInsurance: "Medical Insurance",
    socialInsurance: "Social Insurance",

    // Medical Insurance Modal
    miManagement: "Medical Insurance Management",
    miFamilyMembers: "Family Members",
    miBack: "← Back",
    miManageTiers: "Manage Tiers",
    miInsuranceTiers: "Insurance Tiers",
    miTierName: "Tier Name",
    miMonthlyPriceEgp: "Monthly Price (EGP)",
    miDescriptionOptional: "Description (optional)",
    miRemove: "Remove",
    miNoTiers: "No tiers configured",
    miAddTier: "Add Tier",
    miTierNamePlaceholder: "e.g. Gold",
    miDescriptionPlaceholder: "Coverage details...",
    miTierNamePriceRequired: "Tier name and price are required",
    miNetworkError: "Network error",
    miSearchPlaceholder: "Search by name or ID...",
    miLoadingEmployees: "Loading employees...",
    miMonthlyCost: "Monthly Cost",
    miManage: "Manage",
    miNoEmployees: "No employees found",
    miMembers: "Members",
    miTotalMonthly: "Total Monthly",
    miRelationship: "Relationship",
    miInsuranceTier: "Insurance Tier",
    miNoFamilyMembers: "No family members added yet",
    miAddFamilyMember: "Add Family Member",
    miNewFamilyMember: "New Family Member",
    miFullNamePlaceholder: "Full name",
    miRelationshipPlaceholder: "e.g. Spouse, Son, Daughter",
    miSelectTier: "— Select tier —",
    miFillAllFields: "Please fill all fields",
    miFailedToAdd: "Failed to add member",
    miSaving: "Saving...",
    miActivate: "Activate",
    miDeactivate: "Deactivate",
    miDelete: "Delete",
    miInactive: "Inactive",
    annualLeave: "Annual Leave",
    training: "Training & Development",
    fullFamily: "Full Family",
    govMandated: "Government Mandated",
    paidTimeOff: "Paid Time Off",
    professionalGrowth: "Professional Growth",
    comprehensiveCoverage:
      "Full medical coverage for employee and family members",
    pensionCoverage: "Pension, disability, and unemployment insurance",
    annualVacation: "Annual paid vacation as per Egyptian labor law",
    profDevelopment: "Professional development and skill enhancement programs",
    active: "Active",
    available: "Available",
    daysRemaining: "days remaining",
    companySponsored: "Company sponsored",

    // Payroll Table
    payrollDetails: "Comprehensive Payroll Details",
    employee: "Employee",
    workingDays: "Working Days",
    basicSalary: "Basic Salary",
    allowances: "Allowances",
    grossSalary: "Gross Salary",
    deductions: "Deductions",
    netSalary: "Net Salary",
    kpi: "KPI",
    status: "Status",
    actions: "Actions",
    includingOvertime: "Including overtime",
    taxInsuranceOther: "Tax + Insurance + Other",

    // Employee Details Modal
    employeeDetails: "Employee Details & Payroll Information",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save Changes",
    saving: "Saving...",
    personalInfo: "Personal Information",
    fullName: "Full Name",
    employeeId: "Employee ID",
    email: "Email Address",
    phone: "Phone Number",
    emergencyPhone: "Emergency Phone",
    nationalId: "National ID",
    dateOfBirth: "Date of Birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    maritalStatus: "Marital Status",
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    nationality: "Nationality",
    city: "City",
    country: "Country",
    address: "Address",

    // Work Info
    workInfo: "Work Information",
    position: "Position",
    hiringDate: "Hiring Date",
    contractType: "Contract Type",
    fullTime: "Full-time",
    partTime: "Part-time",
    contract: "Contract",
    temporary: "Temporary",
    workingHours: "Working Hours",
    contractExpiration: "Contract Expiration",
    directManager: "Direct Manager",
    workLocation: "Work Location",
    employmentStatus: "Employment Status",

    // Salary & Earnings
    salaryEarnings: "Salary & Earnings",
    bonus: "Bonus",
    overtimeHours: "Overtime Hours",
    overtimeTotal: "Overtime Total",
    transportation: "Transportation Allowance",
    meal: "Meal Allowance",
    mobile: "Mobile Allowance",
    bonusAdjustments: "Bonus Adjustments",
    taxMonth: "Monthly Tax",
    socialInsurance: "Social Insurance",
    penalty: "Penalty",
    advancePayment: "Advance Payment",

    // Performance
    performance: "Performance & KPI",
    kpiScore: "KPI Score",
    performanceRating: "Performance Rating",
    excellent: "Excellent",
    good: "Good",
    satisfactory: "Satisfactory",
    needsImprovement: "Needs Improvement",

    // Banking
    bankingInfo: "Banking Information",
    bankName: "Bank Name",
    accountNumber: "Account Number",
    iban: "IBAN",
    branchCode: "Branch Code",

    // Actions
    downloadPayslip: "Download Payslip",
    sendEmail: "Send via Email",
    unpay: "Unpay",
    unpayPayroll: "Unpay Payroll",
    unpayConfirm: "Are you sure you want to unpay this payroll? This will reverse the payment status.",
    unpaySuccess: "Payroll unpaid successfully",
    unpayError: "Failed to unpay payroll",
    bulkUnpay: "Bulk Unpay",
    ignoreAttendance: "Ignore Attendance",
    ignoreAttendanceSuccess: "Attendance ignore status updated",
    ignoreAttendanceError: "Failed to update attendance ignore status",
    choosePaidEmployees: "Choose Paid Employees",
    reviewUnpay: "Review Unpay",
    unpayWarning: "⚠️ You are about to unpay payroll",
    unpayWarningDescription: "This action will reverse the paid status for selected employees. They will return to pending status.",
    noPaidEmployees: "No Paid Employees",
    allEmployeesPending: "All employees have pending payroll status",
    importantConfirmUnpay: "⚠️ Important Confirmation Required",
    unpayConfirmationDesc: "You are about to unpay multiple employees. This action cannot be easily undone. All selected employees will be set back to pending status.",
    selectedEmployees: "Selected Employees",
    confirmUnpayAll: "Confirm & Unpay All",
    unpayAllSuccess: "Successfully unpaid {count} employees",
    unpayPartialSuccess: "Unpay completed: {success} successful, {error} failed",
    unpayAllFailed: "Failed to unpay employees",
    selectAtLeastOneEmployee: "Please select at least one employee",
    totalNetSalary: "Total Net Salary",
    processing: "Processing...",

    // Process Payroll Modal
    processNewPayroll: "Process New Payroll",
    selectPeriod: "Select Period",
    chooseEmployees: "Choose Employees",
    configureSettings: "Configure Settings",
    reviewProcess: "Review & Process",
    month: "Month",
    year: "Year",
    startDate: "Start Date",
    endDate: "End Date",
    selectByDepartment: "Select Employees by Department",
    selectByCompany: "Select Employees by Company",
    groupByDepartment: "By Department",
    groupByCompany: "By Company",
    selectAll: "Select All",
    selectAllFiltered: "Select all",
    selected: "selected",
    clearSelection: "Clear",
    selectEmployeeRow: "Select this employee",
    valid: "Valid",
    payrollSettings: "Payroll Settings",
    paymentMethod: "Payment Method",
    bankTransfer: "Bank Transfer",
    cash: "Cash",
    check: "Check",
    digitalWallet: "Digital Wallet",
    paymentDate: "Payment Date",
    processingOptions: "Processing Options",
    includeOvertime: "Include Overtime",
    includeBonuses: "Include Bonuses",
    processTaxes: "Process Income Tax",
    processInsurance: "Process Social Insurance",
    notes: "Notes (Optional)",
    notesPlaceholder: "Add any notes about this payroll run...",
    payrollSummary: "Payroll Summary",
    employees: "Employees",
    grossTotal: "Gross Total",
    taxInsurance: "Tax & Insurance",
    netTotal: "NET TOTAL",
    employeeBreakdown: "Employee Breakdown",
    important: "Important",
    cannotUndo:
      "This action will process payroll for {count} employees and cannot be undone.",
    back: "Back",
    nextStep: "Next Step",
    processing: "Processing...",
    processPayrollBtn: "Process Payroll",

    // Import Modal
    importPayroll: "Import Payroll from Excel",
    upload: "Upload",
    preview: "Preview",
    results: "Results",
    uploadFile: "Click to upload Excel file",
    supportedFormats: "Supports .xlsx, .xls, and .csv files",
    processingFile: "Processing file...",
    expectedFormat: "Expected Excel Format",
    formatDescription:
      "Your Excel file should contain columns: Infinity Code (Required), Employee Name, Payroll Start/End dates, Working days, Absence Days, OverTime Days, Bonus Value, expenses, Achievement, and more.",
    importSettings: "Import Settings",
    skipErrors: "Skip rows with errors",
    autoCalculate: "Auto-calculate missing values from employee data",
    totalRows: "Total Rows",
    validRows: "Valid",
    errorRows: "Errors",
    row: "Row",
    code: "Code",
    name: "Name",
    period: "Period",
    errorsWillBeSkipped: "{count} row(s) have errors and will be skipped.",
    total: "Total",
    successful: "Successful",
    failed: "Failed",
    skipped: "Skipped",
    successMessage: "Successfully imported {count} payroll record(s)!",
    errorsFound: "Errors",
    recordsCreated:
      "The payroll records have been created. You can now review them in the payroll table.",
    done: "Done",
    importing: "Importing...",
    importRecords: "Import {count} Records",
    importingRecords: "Importing payroll records...",
    showMore: "Show More",
    remaining: "remaining",
    // Deductions Modal
    employeeDeductions: "Employee Deductions",
    addDeduction: "Add Deduction",
    deductionType: "Deduction Type",
    selectType: "Select Type",
    absence: "Absence",
    penalty: "Penalty",
    advance: "Advance",
    insurance: "Insurance",
    sickLeave: "Sick Leave 25%",
    lateArrival: "Late Arrival",
    lateArrivalCalcDesc: "Late deduction based on configuration rates",
    calculatingLate: "Loading rates...",
    lateHours: "Late Hours",
    other: "Other",
    amount: "Amount (EGP)",
    date: "Date",
    days: "Days (Optional)",
    description: "Description",
    descriptionPlaceholder: "Deduction description...",
    saveDeduction: "Save Deduction",
    currentDeductions: "Current Deductions",
    loading: "Loading...",
    noDeductions: "No deductions for this employee",
    totalDeductions: "Total Deductions",
    unknown: "Unknown", // Modal titles & actions
    close: "Close",
    view: "View",
    viewDetails: "View Details",

    // Deductions Modal - اللي ناقصة
    employeeDeductions: "Employee Deductions",
    addDeduction: "Add Deduction",
    deductionType: "Deduction Type",
    selectType: "Select Type",
    absence: "Absence",
    penalty: "Penalty",
    advance: "Advance",
    insurance: "Insurance",
    sickLeave: "Sick Leave 25%",
    lateArrival: "Late Arrival",
    lateArrivalCalcDesc: "Late deduction based on configuration rates",
    calculatingLate: "Loading rates...",
    lateHours: "Late Hours",
    other: "Other",
    amount: "Amount (EGP)",
    date: "Date",
    days: "Days (Optional)",
    description: "Description",
    descriptionPlaceholder: "Deduction description...",
    saveDeduction: "Save Deduction",
    currentDeductions: "Current Deductions",
    loading: "Loading...",
    noDeductions: "No deductions for this employee",
    totalDeductions: "Total Deductions",

    //allowances Modal

    employeeAllowances: "Employee Allowances",
    addAllowance: "Add Allowance",
    editAllowance: "Edit Allowance",
    currentAllowances: "Current Allowances",
    noAllowances: "No Allowances Found",
    allowanceType: "Allowance Type",
    saveAllowance: "Save Allowance",
    allowanceAddedSuccess: "Allowance Added Successfully",
    allowanceUpdatedSuccess: "Allowance Updated Successfully",
    allowanceDeletedSuccess: "Allowance Deleted Successfully",
    errorAddingAllowance: "Error Adding Allowance",
    errorDeletingAllowance: "Failed to Delete Allowance",
    confirmDeleteAllowance: "Are you sure you want to delete this allowance?",
    allowances: "Allowances",
    transportation: "Transportation Allowance",
    housing: "Housing Allowance",
    meal: "Meal Allowance",
    variable: "Variable Allowance",
    overtime: "Overtime",
    bonus: "Bonus",
    commission: "Commission",
    representation: "Representation Allowance",
    adjustment: "Adjustment",
    hours: "Hours",
    percentage: "Percentage %",
    baseAmount: "Base Amount",
    isTaxable: "Taxable",
    isRecurring: "Recurring Monthly",
    recurring: "Recurring",
    nonTaxable: "Non-Taxable",
    update: "Update",
    amountType: "Amount Type",
    grossAmount: "Gross (Added to Taxable Income)",
    netAmount: "Net (Added after Tax)",
    preTaxDeduction: "Gross — reduces Taxable Gross Amount",
    postTaxDeduction: "Net — taken from Final Net Amount",
    deductionTreatment: "Deduction Treatment",
    gross: "Gross",
    net: "Net",
    grossDeductionDesc: "This deduction will reduce the taxable gross amount.",
    netDeductionDesc: "This deduction will be taken from the final net amount.",
    // Months
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    2025: "2025",
    2024: "2024",
    2023: "2023",
    2022: "2022",
    2026: "2026",
  },
  ar: {
    success: "نجاح",
    error: "خطأ",
    important: "مهم",
    fillTypeAmount: "يرجى ملء النوع والمبلغ",
    deductionAddedSuccess: "تم إضافة الخصم بنجاح!",
    errorAddingDeduction: "حدث خطأ أثناء إضافة الخصم",
    noDescription: "لا يوجد وصف",
    employeeDataUpdatedSuccess: "تم تحديث بيانات الموظف بنجاح",
    errorSavingEmployeeData: "حدث خطأ أثناء حفظ البيانات",
    payrollProcessedSuccess: "تم معالجة الرواتب بنجاح لـ {count} موظف!",
    payrollProcessingError: "خطأ في معالجة الرواتب: {error}",

    // Employee Details Modal

    // Employee Details Modal
    employeeDetailsTitle: "تفاصيل الموظف ومعلومات الراتب",
    edit: "تعديل",
    cancel: "إلغاء",
    saveChanges: "حفظ التغييرات",
    saving: "جاري الحفظ...",

    // Personal Information
    personalInformation: "المعلومات الشخصية",
    fullName: "الاسم الكامل",
    employeeId: "رقم الموظف",
    emailAddress: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    emergencyPhone: "هاتف الطوارئ",
    nationalId: "الرقم القومي",
    dateOfBirth: "تاريخ الميلاد",
    gender: "النوع",
    selectGender: "اختر النوع",
    male: "ذكر",
    female: "أنثى",
    maritalStatus: "الحالة الاجتماعية",
    selectStatus: "اختر الحالة",
    single: "أعزب",
    married: "متزوج",
    divorced: "مطلق",
    widowed: "أرمل",
    nationality: "الجنسية",
    city: "المدينة",
    country: "الدولة",
    address: "العنوان",

    // Work Information
    workInformation: "معلومات العمل",
    department: "القسم",
    position: "المنصب",
    hiringDate: "تاريخ التعيين",
    contractType: "نوع العقد",
    selectType: "اختر النوع",
    fullTime: "دوام كامل",
    partTime: "دوام جزئي",
    contract: "عقد",
    temporary: "مؤقت",
    workingHours: "ساعات العمل",
    contractExpiration: "انتهاء العقد",
    directManager: "المدير المباشر",
    workLocation: "موقع العمل",
    employmentStatus: "حالة التوظيف",

    // Salary & Earnings
    salaryAndEarnings: "الراتب والمكاسب",
    basicSalary: "الراتب الأساسي",
    bonus: "المكافأة",
    overtimeHours: "ساعات العمل الإضافي",
    overtimeTotal: "إجمالي الوقت الإضافي",
    transportationAllowance: "بدل المواصلات",
    mealAllowance: "بدل الوجبات",
    mobileAllowance: "بدل الهاتف",
    bonusAdjustments: "تعديلات المكافأة",
    grossSalary: "الراتب الإجمالي",
    payrollSettings: "إعدادات الراتب",
    paymentMethod: "طريقة الدفع",
    paymentDate: "تاريخ الدفع",
    processingOptions: "خيارات المعالجة",
    includeOvertime: "تضمين الوقت الإضافي",
    includeBonuses: "تضمين المكافآت",
    processTaxes: "معالجة ضريبة الدخل",
    processInsurance: "معالجة التأمين الاجتماعي",
    notes: "ملاحظات (اختياري)",
    addNotesPayroll: "أضف أي ملاحظات حول معالجة الراتب هذه...",
    reviewProcess: "المراجعة والمعالجة",
    payrollSummary: "ملخص الرواتب",
    employees: "الموظفون",
    grossTotal: "الإجمالي الإجمالي",
    deductions: "الخصومات",
    taxInsurance: "الضرائب والتأمين",
    netTotal: "الإجمالي الصافي",
    employeeBreakdown: "تفصيل الموظفين",
    important: "مهم",
    processPayrollWarning:
      "سيؤدي هذا الإجراء إلى معالجة الرواتب لـ {count} موظفين ولا يمكن التراجع عنه.",

    // Performance & KPI
    performanceKPI: "الأداء ومؤشرات الأداء",
    kpiScore: "درجة الأداء",
    performanceRating: "تقييم الأداء",
    excellent: "ممتاز",
    good: "جيد",
    satisfactory: "مرضي",
    needsImprovement: "يحتاج تحسين",

    // Banking Information
    bankingInformation: "المعلومات البنكية",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    iban: "الآيبان",
    branchCode: "كود الفرع",

    // Action Buttons
    downloadPayslip: "تحميل كشف الراتب",
    sendViaEmail: "إرسال عبر البريد",
    unpay: "إلغاء الدفع",
    unpayPayroll: "إلغاء دفع الراتب",
    unpayConfirm: "هل أنت متأكد من أنك تريد إلغاء دفع هذا الراتب؟ سيؤدي هذا إلى عكس حالة الدفع.",
    unpaySuccess: "تم إلغاء دفع الراتب بنجاح",
    unpayError: "فشل إلغاء دفع الراتب",
    bulkUnpay: "إلغاء دفع جماعي",
    ignoreAttendance: "تجاهل الحضور",
    ignoreAttendanceSuccess: "تم تحديث حالة تجاهل الحضور",
    ignoreAttendanceError: "فشل تحديث حالة تجاهل الحضور",
    choosePaidEmployees: "اختر الموظفين المدفوعين",
    reviewUnpay: "مراجعة إلغاء الدفع",
    unpayWarning: "⚠️ أنت على وشك إلغاء دفع الراتب",
    unpayWarningDescription: "هذا الإجراء سيعكس حالة الدفع للموظفين المختارين. سيعودون إلى حالة معلقة.",
    noPaidEmployees: "لا يوجد موظفون مدفوعون",
    allEmployeesPending: "جميع الموظفين لديهم حالة راتب معلقة",
    importantConfirmUnpay: "⚠️ تأكيد مهم مطلوب",
    unpayConfirmationDesc: "أنت على وشك إلغاء دفع رواتب عدة موظفين. لا يمكن التراجع عن هذا الإجراء بسهولة. سيتم إعادة تعيين جميع الموظفين المختارين إلى حالة معلقة.",
    selectedEmployees: "الموظفون المختارون",
    confirmUnpayAll: "تأكيد وإلغاء الدفع للجميع",
    unpayAllSuccess: "تم إلغاء دفع {count} موظف بنجاح",
    unpayPartialSuccess: "اكتمل إلغاء الدفع: {success} ناجح، {error} فشل",
    unpayAllFailed: "فشل في إلغاء دفع الموظفين",
    selectAtLeastOneEmployee: "يرجى تحديد موظف واحد على الأقل",
    totalNetSalary: "إجمالي الراتب الصافي",
    processing: "جاري المعالجة...",

    // Status Options
    active: "نشط",
    paid: "مدفوع",
    pending: "معلق",
    processing: "قيد المعالجة",
    onHold: "معلق",
    // Header
    pageTitle: "نظام إدارة الرواتب",
    currency: "جنيه",
    nextStep: "الخطوة التالية",
    templateButton: "النموذج",
    templateButtonTitle: "عرض تفاصيل النموذج",
    templateBuilder: "أداة تخصيص النموذج",
    templateBuilderSubtitle: "اختر الأعمدة المراد تضمينها، أو قم بتصدير كل شيء.",
    buildCustomTemplate: "تخصيص النموذج…",
    exportFullTemplate: "تصدير النموذج الكامل",
    exportSelection: "تصدير",
    searchColumns: "بحث في الأعمدة…",
    kindAll: "الكل",
    kindAllowances: "البدلات",
    kindDeductions: "الخصومات",
    showVariants: "عرض",
    variantNet: "صافي",
    variantGross: "إجمالي",
    variantDaysNet: "أيام (صافي)",
    variantDaysGross: "أيام (إجمالي)",
    alwaysIncluded: "مدرج دائمًا",
    requiredColumns: "مطلوب",
    columnsSelectedSummary: "{selected} من أصل {total} عمود",
    noColumnsSelected: "يرجى تحديد عمود واحد على الأقل للتصدير.",
    addColumn: "إضافة عمود",
    customColumnLabel: "اسم العمود",
    customColumnKind: "النوع",
    customColumnPreview: "العناوين التي سيتم إنشاؤها",
    customColumnStoredAs: "يُخزن كنوع",
    customColumnRecognised: "متعرف عليه من قِبل المستورد",
    customBadge: "مخصص",
    presets: "النماذج المحفوظة",
    fullTemplate: "النموذج الكامل",
    newPreset: "نموذج محفوظ جديد",
    savePreset: "حفظ النموذج",
    saveAsNew: "حفظ كجديد…",
    updatePreset: "تحديث \"{name}\"",
    presetModified: "معدل",
    presetName: "الاسم",
    presetDescription: "الوصف",
    presetScopePersonal: "أنا فقط",
    presetScopeCompany: "الجميع في هذه الشركة",
    setAsDefault: "تعيين كنموذج افتراضي لي",
    duplicatePreset: "نسخ",
    sharePreset: "مشاركة",
    unsharePreset: "إلغاء المشاركة",
    deletePreset: "حذف",
    templatePresetSaved: "تم حفظ النموذج بنجاح",
    templatePresetUpdated: "تم تحديث النموذج بنجاح",
    templatePresetDeleted: "تم حذف النموذج بنجاح",
    confirmDeletePreset: "هل تريد بالتأكيد حذف هذا النموذج؟ لا يمكن التراجع عن هذا الإجراء.",
    confirmSharePreset: "هل تريد مشاركة هذا النموذج مع الجميع في الشركة؟",
    presetNameTaken: "لديك بالفعل نموذج بهذا الاسم.",
    errorLoadingColumns: "تعذر تحميل قائمة الأعمدة.",
    errorExportingTemplate: "تعذر إنشاء النموذج.",
    clearSearch: "مسح البحث",
    noColumnsMatch: "لا توجد أعمدة تطابق",
    selectedOfTotal: "{selected} محدد / {total}",
    selectAllFiltered: "تحديد الكل",
    clearAllSelection: "إلغاء التحديد",
    quantityColumnNotice: "عمود كمية (ساعات/أيام)",
    // Action Buttons
    processPayroll: "معالجة رواتب جديدة",
    import: "استيراد",
    importExcel: "استيراد من Excel",
    importAllowancesDeductions: "استيراد البدلات والخصومات",
    importAllowancesDeductionstitle: "استيراد البدلات والخصومات",
    exportTemplate: "تصدير النموذج",
    exportAllowanceDeductionTemplate: "تصدير نموذج البدلات/الخصومات",
    exportAllowanceDeductionTemplatetitle: "تصدير نموذج البدلات/الخصومات",


    exportPayrollExcel: "تصدير إلى Excel",
    exportPayrollPDF: "تحميل كـ PDF",
    exportDate: "تاريخ التصدير",
    payrollExportSuccess: "تم تصدير الرواتب إلى Excel بنجاح!",
    payrollExportSuccessPDF: "تم تصدير الرواتب إلى PDF بنجاح!",
    payrollExportError: "خطأ في تصدير الرواتب إلى Excel",
    payrollExportErrorPDF: "خطأ في تصدير الرواتب إلى PDF",
    allowanceDeductionImportSuccess: "تم استيراد البدلات والخصومات بنجاح",
    allowanceDeductionImportError: "خطأ أثناء استيراد البدلات والخصومات",
    importingAllowancesDeductions: "جاري استيراد البدلات والخصومات...",
    adImportResultsTitle: "اكتمل الاستيراد",
    adImportResultsSubtitle: "تمت معالجة الملف. راجع التفاصيل أدناه.",
    adImportTotal: "الإجمالي",
    adImportProcessed: "تمت المعالجة",
    adImportFailed: "فشل",
    adImportDuplicates: "التكرارات",
    adImportAllowancesCreated: "البدلات المُنشأة",
    adImportDeductionsCreated: "الخصومات المُنشأة",
    adImportNoIssues: "تم استيراد جميع الصفوف بنجاح دون أي مشاكل!",
    adImportErrorsSection: "الصفوف الفاشلة",
    adImportDuplicatesSection: "صفوف مكررة تم اكتشافها",
    adImportDuplicatesHint:
      "هذه التركيبات من كود الموظف والتاريخ تظهر أكثر من مرة في الملف المرفوع — تم استيراد كل الصفوف المطابقة رغم ذلك، فتأكد من أنها ليست تكرارًا غير مقصود.",
    adImportEmployeeCode: "كود الموظف",
    adImportDate: "التاريخ",
    adImportOccurrences: "عدد التكرارات",
    adImportReason: "السبب",
    // manageVisibility: "إدارة الظهور",

    // قواعد الظهور
    visibilityRulesTitle: "قواعد ظهور المسؤولين",
    visibleEmployees: "الموظفون المرئيون",
    addVisibilityRule: "إضافة قاعدة ظهور",
    removeVisibilityRule: "إزالة الوصول",
    selectAdmin: "اختر المسؤول",
    selectEmployee: "اختر الموظف",
    adminName: "اسم المسؤول",
    employeeName: "اسم الموظف",
    visibilityAdded: "تمت إضافة قاعدة الظهور بنجاح",
    visibilityRemoved: "تمت إزالة قاعدة الظهور بنجاح",
    loadingVisibilityRules: "جاري تحميل قواعد الظهور...",
    noVisibilityRules: "لم يتم تكوين قواعد ظهور",
    bulkAddRules: "إضافة قواعد متعددة",
    selectMultipleEmployees: "اختر عدة موظفين",
    employeesSelected: "موظف محدد",
    addSelectedEmployees: "إضافة الموظفين المحددين",
    searchEmployees: "ابحث عن الموظفين...",
    allEmployees: "جميع الموظفين",
    visibleToAdmin: "مرئي لهذا المسؤول",
    notVisibleToAdmin: "غير مرئي لهذا المسؤول",

    // Statistics
    totalGross: "إجمالي الراتب ",
    employeesPaid: "الموظفون المدفوعون",
    pendingPayments: "المدفوعات المعلقة",
    averageKPI: "إجمالي الخصومات",
    monthlyGross: "الرواتب الإجمالية الشهرية",
    currentMonth: "الشهر الحالي",
    awaitingApproval: "في انتظار الموافقة",
    performanceIndicator: "إجمالي الخصومات الشهرية",

    // Filters
    filterSearch: "تصفية وبحث",
    searchEmployees: "البحث عن الموظفين",
    searchPlaceholder: "ابحث بالاسم أو رقم الموظف...",
    paymentStatus: "حالة الدفع",
    allStatuses: "جميع الحالات",
    paid: "مدفوع",
    pending: "معلق",
    approved: "معتمد/قيد المعالجة",
    rejected: "مرفوض/معلق",
    department: "القسم/الموقع",
    allDepartments: "جميع الأقسام",
    payPeriod: "فترة الدفع",
    payPeriodMonth: "فترة الدفع (الشهر)",
    payPeriodYear: "فترة الدفع (السنة)",
    refreshData: "تحديث البيانات",
    activeFilters: "الفلاتر النشطة",
    clearAll: "مسح الكل",
    workingCompany: "الشركة",
    allCompanies: "جميع الشركات",
    laborMode: "نظام العمل",
    allLaborModes: "جميع أنظمة العمل",
    insource: "داخلي (توظيف مباشر)",
    outsource: "خارجي (تعاقد)",

    // Benefits
    benefitsPackage: "حزمة مزايا الموظفين",
    medicalInsurance: "التأمين الطبي",
    socialInsurance: "التأمينات الاجتماعية",

    // Medical Insurance Modal
    miManagement: "إدارة التأمين الطبي",
    miFamilyMembers: "أفراد العائلة",
    miBack: "→ رجوع",
    miManageTiers: "إدارة الفئات",
    miInsuranceTiers: "فئات التأمين",
    miTierName: "اسم الفئة",
    miMonthlyPriceEgp: "السعر الشهري (جنيه)",
    miDescriptionOptional: "الوصف (اختياري)",
    miRemove: "حذف",
    miNoTiers: "لا توجد فئات مضافة",
    miAddTier: "إضافة فئة",
    miTierNamePlaceholder: "مثال: ذهبي",
    miDescriptionPlaceholder: "تفاصيل التغطية...",
    miTierNamePriceRequired: "اسم الفئة والسعر مطلوبان",
    miNetworkError: "خطأ في الشبكة",
    miSearchPlaceholder: "ابحث بالاسم أو الرقم الوظيفي...",
    miLoadingEmployees: "جاري تحميل الموظفين...",
    miMonthlyCost: "التكلفة الشهرية",
    miManage: "إدارة",
    miNoEmployees: "لا يوجد موظفون",
    miMembers: "الأعضاء",
    miTotalMonthly: "الإجمالي الشهري",
    miRelationship: "صلة القرابة",
    miInsuranceTier: "فئة التأمين",
    miNoFamilyMembers: "لم يتم إضافة أفراد عائلة بعد",
    miAddFamilyMember: "إضافة فرد عائلة",
    miNewFamilyMember: "فرد عائلة جديد",
    miFullNamePlaceholder: "الاسم الكامل",
    miRelationshipPlaceholder: "مثال: زوج، ابن، ابنة",
    miSelectTier: "— اختر الفئة —",
    miFillAllFields: "يرجى ملء جميع الحقول",
    miFailedToAdd: "فشل إضافة الفرد",
    miSaving: "جاري الحفظ...",
    miActivate: "تفعيل",
    miDeactivate: "تعطيل",
    miDelete: "حذف نهائي",
    miInactive: "غير نشط",
    annualLeave: "الإجازة السنوية",
    training: "التدريب والتطوير",
    fullFamily: "العائلة_الكاملة",
    govMandated: "إلزامي_  حكومياً",
    paidTimeOff: "إجازة مدفوعة الأجر",
    professionalGrowth: "النمو_المهني",
    comprehensiveCoverage: "تغطية طبية شاملة للموظف وأفراد عائلته",
    pensionCoverage: "التأمين التقاعدي والعجز والبطالة",
    annualVacation: "إجازة سنوية مدفوعة حسب قانون العمل المصري",
    profDevelopment: "برامج التطوير المهني وتحسين المهارات",
    active: "نشط",
    available: "متاح",
    daysRemaining: "يوم متبقي",
    companySponsored: "برعاية الشركة",

    // Payroll Table
    payrollDetails: "تفاصيل الرواتب الشاملة",
    employee: "الموظف",
    workingDays: "أيام العمل",
    basicSalary: "الراتب الأساسي",
    allowances: "البدلات",
    grossSalary: "الراتب الإجمالي",
    deductions: "الخصومات",
    netSalary: "صافي الراتب",
    kpi: "الأداء",
    status: "الحالة",
    actions: "الإجراءات",
    includingOvertime: "+ الوقت الإضافي",
    taxInsuranceOther: "الضرائب + التأمين + أخرى",

    // Employee Details Modal
    employeeDetails: "تفاصيل الموظف ومعلومات الراتب",
    edit: "تعديل",
    cancel: "إلغاء",
    save: "حفظ التغييرات",
    saving: "جاري الحفظ...",
    personalInfo: "المعلومات الشخصية",
    fullName: "الاسم الكامل",
    employeeId: "رقم الموظف",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    emergencyPhone: "هاتف الطوارئ",
    nationalId: "الرقم القومي",
    dateOfBirth: "تاريخ الميلاد",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    maritalStatus: "الحالة الاجتماعية",
    single: "أعزب",
    married: "متزوج",
    divorced: "مطلق",
    widowed: "أرمل",
    nationality: "الجنسية",
    city: "المدينة",
    country: "الدولة",
    address: "العنوان",

    // Work Info
    workInfo: "معلومات العمل",
    position: "المنصب",
    hiringDate: "تاريخ التعيين",
    contractType: "نوع العقد",
    fullTime: "دوام كامل",
    partTime: "دوام جزئي",
    contract: "عقد",
    temporary: "مؤقت",
    workingHours: "ساعات العمل",
    contractExpiration: "انتهاء العقد",
    directManager: "المدير المباشر",
    workLocation: "موقع العمل",
    employmentStatus: "حالة التوظيف",

    // Salary & Earnings
    salaryEarnings: "الراتب والمكاسب",
    bonus: "المكافأة",
    overtimeHours: "ساعات العمل الإضافي",
    overtimeTotal: "إجمالي الوقت الإضافي",
    transportation: "بدل المواصلات",
    meal: "بدل الوجبات",
    mobile: "بدل الهاتف",
    bonusAdjustments: "تعديلات المكافأة",
    taxMonth: "ضريبة شهرية",
    socialInsurance: "التأمين الاجتماعي",
    penalty: "جزاء",
    advancePayment: "دفعة مقدمة",

    // Performance
    performance: "الأداء والكفاءة",
    kpiScore: "درجة الأداء",
    performanceRating: "تقييم الأداء",
    excellent: "ممتاز",
    good: "جيد",
    satisfactory: "مرضي",
    needsImprovement: "يحتاج تحسين",

    // Banking
    bankingInfo: "المعلومات البنكية",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    iban: "الآيبان",
    branchCode: "كود الفرع",

    // Actions
    downloadPayslip: "تحميل كشف الراتب",
    sendEmail: "إرسال عبر البريد",

    // Process Payroll Modal
    processNewPayroll: "معالجة رواتب جديدة",
    selectPeriod: "اختر الفترة",
    chooseEmployees: "اختر الموظفين",
    configureSettings: "إعداد الإعدادات",
    reviewProcess: "مراجعة ومعالجة",
    month: "الشهر",
    year: "السنة",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    selectByDepartment: "اختر الموظفين حسب القسم",
    selectByCompany: "اختر الموظفين حسب الشركة",
    groupByDepartment: "حسب القسم",
    groupByCompany: "حسب الشركة",
    selectAll: "تحديد الكل",
    selectAllFiltered: "تحديد الكل",
    selected: "محدد",
    clearSelection: "إلغاء التحديد",
    selectEmployeeRow: "تحديد هذا الموظف",
    valid: "صالح",
    payrollSettings: "إعدادات الرواتب",
    paymentMethod: "طريقة الدفع",
    bankTransfer: "تحويل بنكي",
    cash: "نقداً",
    check: "شيك",
    digitalWallet: "محفظة رقمية",
    paymentDate: "تاريخ الدفع",
    processingOptions: "خيارات المعالجة",
    includeOvertime: "تضمين الوقت الإضافي",
    includeBonuses: "تضمين المكافآت",
    processTaxes: "معالجة ضريبة الدخل",
    processInsurance: "معالجة التأمينات الاجتماعية",
    notes: "ملاحظات (اختياري)",
    notesPlaceholder: "أضف أي ملاحظات عن هذه الدفعة...",
    payrollSummary: "ملخص الرواتب",
    employees: "الموظفون",
    grossTotal: "الإجمالي الكلي",
    taxInsurance: "الضرائب والتأمين",
    netTotal: "الصافي الكلي",
    employeeBreakdown: "تفصيل الموظفين",
    important: "هام",
    cannotUndo:
      "سيتم معالجة رواتب {count} موظف ولا يمكن التراجع عن هذا الإجراء.",
    back: "رجوع",
    nextStep: "الخطوة التالية",
    processing: "جاري المعالجة...",
    processPayrollBtn: "معالجة الرواتب",

    // Import Modal
    importPayroll: "استيراد الرواتب من Excel",
    upload: "رفع",
    preview: "معاينة",
    results: "النتائج",
    uploadFile: "اضغط لرفع ملف Excel",
    supportedFormats: "يدعم ملفات .xlsx و .xls و .csv",
    processingFile: "جاري معالجة الملف...",
    expectedFormat: "تنسيق Excel المتوقع",
    formatDescription:
      "يجب أن يحتوي ملف Excel على أعمدة: كود الموظف (مطلوب)، اسم الموظف، تواريخ بداية/نهاية الرواتب، أيام العمل، أيام الغياب، أيام العمل الإضافي، قيمة المكافأة، المصروفات، الإنجاز، والمزيد.",
    importSettings: "إعدادات الاستيراد",
    skipErrors: "تخطي الصفوف التي بها أخطاء",
    autoCalculate: "احسب القيم المفقودة تلقائياً من بيانات الموظف",
    totalRows: "إجمالي الصفوف",
    validRows: "صالح",
    errorRows: "أخطاء",
    row: "صف",
    code: "الكود",
    name: "الاسم",
    period: "الفترة",
    errorsWillBeSkipped: "{count} صف به أخطاء وسيتم تخطيه.",
    total: "الإجمالي",
    successful: "ناجح",
    failed: "فشل",
    skipped: "متخطى",
    successMessage: "تم استيراد {count} سجل رواتب بنجاح!",
    errorsFound: "أخطاء",
    recordsCreated:
      "تم إنشاء سجلات الرواتب. يمكنك الآن مراجعتها في جدول الرواتب.",
    done: "تم",
    importing: "جاري الاستيراد...",
    importRecords: "استيراد {count} سجل",
    importingRecords: "جاري استيراد سجلات الرواتب...",

    showing: "عرض",
    of: "من",
    previous: "السابق",
    next: "التالي",
    // Deductions Modal
    employeeDeductions: "خصومات الموظف",
    addDeduction: "إضافة خصم",
    deductionType: "نوع الخصم",
    selectType: "اختر النوع",
    absence: "غياب",
    penalty: "جزاء",
    advance: "سلفة",
    insurance: "تأمين",
    sickLeave: "إجازة مرضية 25%",
    lateArrival: "تأخير",
    lateArrivalCalcDesc: "خصم التأخير بناءً على الإعدادات",
    calculatingLate: "جاري تحميل المعدلات...",
    lateHours: "ساعات التأخير",
    other: "أخرى",
    amount: "المبلغ (جنيه)",
    date: "التاريخ",
    days: "الأيام (اختياري)",
    description: "الوصف",
    descriptionPlaceholder: "وصف الخصم...",
    saveDeduction: "حفظ الخصم",
    currentDeductions: "الخصومات الحالية",
    loading: "جاري التحميل...",
    noDeductions: "لا توجد خصومات لهذا الموظف",
    totalDeductions: "إجمالي الخصومات",
    unknown: "غير معروف",
    close: "إغلاق",
    view: "عرض",
    showMore: "عرض المزيد",
    remaining: "متبقي",
    viewDetails: "عرض التفاصيل",

    // Deductions Modal
    employeeDeductions: "خصومات الموظف",
    addDeduction: "إضافة خصم",
    deductionType: "نوع الخصم",
    selectType: "اختر النوع",
    absence: "غياب",
    penalty: "جزاء",
    advance: "سلفة",
    insurance: "تأمين",
    sickLeave: "إجازة مرضية 25%",
    lateArrival: "تأخير",
    lateArrivalCalcDesc: "خصم التأخير بناءً على الإعدادات",
    calculatingLate: "جاري تحميل المعدلات...",
    lateHours: "ساعات التأخير",
    other: "أخرى",
    amount: "المبلغ (جنيه)",
    date: "التاريخ",
    days: "الأيام (اختياري)",
    description: "الوصف",
    descriptionPlaceholder: "وصف الخصم...",
    saveDeduction: "حفظ الخصم",
    currentDeductions: "الخصومات الحالية",
    loading: "جاري التحميل...",
    noDeductions: "لا توجد خصومات لهذا الموظف",
    totalDeductions: "إجمالي الخصومات",

    //Allownce Model
    // عربي (ar)
    employeeAllowances: "بدلات الموظف",
    addAllowance: "إضافة بدل",
    editAllowance: "تعديل البدل",
    currentAllowances: "البدلات الحالية",
    noAllowances: "لا توجد بدلات",
    allowanceType: "نوع البدل",
    saveAllowance: "حفظ البدل",
    allowanceAddedSuccess: "تمت إضافة البدل بنجاح",
    allowanceUpdatedSuccess: "تم تعديل البدل بنجاح",
    allowanceDeletedSuccess: "تم حذف البدل بنجاح",
    errorAddingAllowance: "خطأ في إضافة البدل",
    errorDeletingAllowance: "فشل حذف البدل",
    confirmDeleteAllowance: "هل أنت متأكد من حذف هذا البدل؟",
    allowances: "البدلات",
    transportation: "بدل انتقالات",
    housing: "بدل سكن",
    meal: "بدل وجبات",
    variable: "بدل متغير",
    overtime: "أوفر تايم",
    bonus: "مكافأة",
    commission: "عمولة",
    representation: "بدل تمثيل",
    adjustment: "تسوية",
    hours: "ساعات",
    percentage: "النسبة %",
    baseAmount: "المبلغ الأساسي",
    isTaxable: "خاضع للضريبة",
    isRecurring: "متكرر شهرياً",
    recurring: "متكرر",
    nonTaxable: "غير خاضع للضريبة",
    update: "تحديث",
    amountType: "نوع المبلغ",
    grossAmount: "إجمالي (يُضاف للدخل الخاضع للضريبة)",
    netAmount: "صافي (يُضاف بعد الضريبة)",
    preTaxDeduction: "إجمالي — يُقلل المبلغ الإجمالي الخاضع للضريبة",
    postTaxDeduction: "صافي — يُخصم من المبلغ الصافي النهائي",
    deductionTreatment: "معالجة الخصم",
    gross: "إجمالي",
    net: "صافي",
    grossDeductionDesc: "هذا الخصم سيقلل من الإجمالي الخاضع للضريبة.",
    netDeductionDesc: "هذا الخصم سيتم اقتطاعه من الصافي النهائي.",

    // Months
    january: "يناير",
    february: "فبراير",
    march: "مارس",
    april: "أبريل",
    may: "مايو",
    june: "يونيو",
    july: "يوليو",
    august: "أغسطس",
    september: "سبتمبر",
    october: "أكتوبر",
    november: "نوفمبر",
    december: "ديسمبر",

    2025: "٢٠٢٥",
    2024: "٢٠٢٤",
    2023: "٢٠٢٣",
    2022: "٢٠٢٢",
    2026: "٢٠٢٦",
  },
};
export default translations;
